import * as React from 'react';

export const EducationTab = () => {
  return <div>TBA tab content: EducationTab</div>;
};
